import React from 'react';

const LessonEngagement = () => {
  return (
    <div className="DataCard px-24 pt-24 pb-24">
      Engagement Component Placeholder
    </div>
  );
};

export default props => <LessonEngagement {...props} />;
